// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-micro-up-down';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M6.415 7.47h5.17c.31 0 .517-.147.362-.265L9.362 4.58a.654.654 0 0 0-.62-.059c-.052.03-.104.03-.104.06L6.053 7.205c-.155.118.051.265.362.265zm5.17 3.06h-5.17c-.31 0-.517.147-.362.265l2.585 2.625a.654.654 0 0 0 .62.059c.052-.03.104-.03.104-.06l2.585-2.624c.155-.118-.051-.265-.362-.265z'
  />
);

export const viewBox = '0 0 18 18';
